var React = require('react');

function Media (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.66666 10.7834L9.6 16.6667H33.3333V30H6.66666V10.7834ZM36.6667 6.66669H30L33.3333 13.3334H28.3333L25 6.66669H21.6667L25 13.3334H20L16.6667 6.66669H13.3333L16.6667 13.3334H11.6667L8.33333 6.66669H6.66666C4.83333 6.66669 3.34999 8.16669 3.34999 10L3.33333 30C3.33333 31.8334 4.83333 33.3334 6.66666 33.3334H33.3333C35.1667 33.3334 36.6667 31.8334 36.6667 30V6.66669Z"}));
}

Media.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Media;

Media.default = Media;
